/**
 * CSS.
 */
/**
 * Internal dependencies
 */
import './favorite.css';

/**
 * WordPress dependencies
 */
import apiFetch from '@wordpress/api-fetch';

const initFavorites = () => {
	const addItemToLocalStorage = (info) => {
		const favorites = JSON.parse(localStorage.getItem('favorites')) || [];
		const exists = favorites.find((item) => item.title === info.title);

		if (!exists) {
			// add to first index
			favorites.unshift(info);
			localStorage.setItem('favorites', JSON.stringify(favorites));
		}

		populateFavorites();
	};

	const removeItemFromLocalStorage = (index) => {
		const favorites = JSON.parse(localStorage.getItem('favorites')) || [];
		favorites.splice(index, 1);
		localStorage.setItem('favorites', JSON.stringify(favorites));
	};

	const form = document.querySelector('.fibo-favorite-mail-form');
	const footer = document.querySelector('.fibo-favorite-modal__footer');

	const submitForm = (e) => {
		e.preventDefault();

		const formData = document.querySelector('.fibo-favorite-data');
		const mail = document.querySelector('.fibo-favorite-mail');
		const nonce = document.querySelector('.fibo-favorite-nonce');
		const language = window.dekodeFrontend.calculator.lang;

		apiFetch.use(apiFetch.createNonceMiddleware(nonce.value));

		apiFetch({
			path: '/fibo/favorite',
			method: 'POST',
			data: {
				mail: mail.value,
				favorites: formData.value,
				lang: language,
			},
		})
			.then(() => {
				footer.classList.toggle('active');
			})
			.catch((error) => {
				console.log(error); // eslint-disable-line no-console
			});
	};

	if (form) {
		form.addEventListener('submit', submitForm);
	}

	const formToggle = document.querySelector('.fibo-favorite-form-toggle');

	if (formToggle) {
		formToggle.addEventListener('click', () => {
			footer.classList.toggle('active');
		});
	}

	const favoritesModal = document.querySelector('.fibo-favorite-modal');
	const addToFavoriteButtons = document.querySelectorAll('.fibo-favorite-add');
	const closeModal = document.querySelectorAll('.fibo-favorite-modal-close');
	const openModal = document.querySelectorAll(".fibo-favorite-open, [href='#fibo-favorite']");

	if (closeModal?.length) {
		[].forEach.call(closeModal, (button) => {
			button.addEventListener('click', () => {
				favoritesModal.classList.add('hide');

				// delay to allow animation
				setTimeout(() => {
					document.body.style.overflow = 'auto';
					favoritesModal.classList.remove('active');
					favoritesModal.classList.remove('hide');
				}, 250);
			});
		});
	}

	if (openModal?.length) {
		[].forEach.call(openModal, (button) => {
			button.addEventListener('click', () => {
				favoritesModal.classList.add('active');
				document.body.style.overflow = 'hidden';
			});
		});
	}

	if (addToFavoriteButtons?.length) {
		[].forEach.call(addToFavoriteButtons, (button) => {
			button.addEventListener('click', () => {
				const metas = document.querySelectorAll('.fibo-products-meta-item');
				const metasObject = {};

				[].forEach.call(metas, (meta) => {
					const label = meta.dataset.metaLabel;
					const value = meta.querySelector('p').innerHTML;
					metasObject[label] = value;
				});

				button.classList.remove('active');
				void button.offsetWidth;
				button.classList.add('active');

				let image = document.querySelector('.fibo-products-hero .swiper-slide-active img')?.src;

				if (!image) {
					image = document.querySelector('.fibo-products-hero .swiper-slide img')?.src;
				}

				const code = document.querySelector(
					'.fibo-products-meta-item[data-meta-key="product_code"]'
				)?.innerText;

				const info = {
					title: document.querySelector('.wp-block-post-title')?.innerHTML,
					collection: document.querySelector('.taxonomy-collections a')?.innerHTML,
					image,
					metas: metasObject,
					url: button.dataset?.url ?? '#',
					code,
				};

				addItemToLocalStorage(info);
				favoritesModal.classList.add('active');

				document.body.style.overflow = 'hidden';
			});
		});
	}

	const populateFavorites = () => {
		const favorites = JSON.parse(localStorage.getItem('favorites')) || [];

		const favoritesContainer = document.querySelector('.fibo-favorite-modal__body-items');

		const formData = document.querySelector('.fibo-favorite-data');

		if (formData) {
			formData.value = JSON.stringify(favorites);
		}

		if (favoritesContainer) {
			favoritesContainer.innerHTML = '';

			[].forEach.call(favorites, (item, index) => {
				const newItem = document.createElement('div');
				// set href as item.url
				newItem.classList.add('fibo-favorite-item');
				newItem.innerHTML = `
					<a href="${item.url ?? '#'}" class="fibo-favorite-item__link">
					<div class="fibo-favorite-item__image">
						<img src="${item.image}" alt="${item.title}" />
					</div>
					<div class="fibo-favorite-item__content">
						<div class="fibo-favorite-item__collection">
							${item?.code ?? ''}
						</div>
						<h3 class="fibo-favorite-item__title">${item.title}</h3>
					</div>
					</a>
					<button
						class="fibo-favorite-modal__close fibo-favorite-remove-item"
					>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="24" width="24" class="t2-icon" aria-hidden="true" focusable="false"><path d="m12 13.4-4.9 4.9c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.2-.2-.3-.4-.3-.7s.1-.5.3-.7l4.9-4.9-4.9-4.9c-.2-.2-.3-.4-.3-.7 0-.3.1-.5.3-.7.2-.2.4-.3.7-.3.3 0 .5.1.7.3l4.9 4.9 4.9-4.9c.2-.2.4-.3.7-.3s.5.1.7.3c.2.2.3.4.3.7 0 .3-.1.5-.3.7L13.4 12l4.9 4.9c.2.2.3.4.3.7s-.1.5-.3.7c-.2.2-.4.3-.7.3s-.5-.1-.7-.3L12 13.4z"></path></svg>
					</button>
				`;

				favoritesContainer.appendChild(newItem);

				const favoriteItems = document.querySelectorAll('.fibo-favorite-item');

				if (favoriteItems?.length) {
					[].forEach.call(favoriteItems, (favItem) => {
						const removeButton = favItem.querySelector('.fibo-favorite-remove-item');
						removeButton.addEventListener('click', () => {
							removeItemFromLocalStorage(index);
							favItem.classList.add('removed');
						});
					});
				}
			});
		}
	};

	populateFavorites();
};

window.addEventListener('DOMContentLoaded', initFavorites);
